// test193
(193 && 0);
